import type { ClassValue } from "svelte/elements";
import { tw } from "@core/utils/svelte/tw.js";
import { ButtonSize } from "./ButtonSize.js";
import { ButtonVariant } from "./ButtonVariant.js";

const commonClass = tw(
	"relative",
	"cursor-pointer [&:not(.loading)]:disabled:cursor-not-allowed [&:not(.loading)]:disabled:opacity-50",
	"inline-flex justify-center items-center [font-feature-settings:'ss04'_1]",
	"uppercase font-sans font-semibold tracking-[.16em] text-sm/none rounded-full",
	"[&:not(:disabled):hover:active]:scale-95 transition duration-150 ease-in-out",
);

const sizeClasses: Record<ButtonSize, ClassValue> = {
	[ButtonSize.Medium]: tw("px-8 h-14"),
	[ButtonSize.Large]: tw("px-8 h-[4.5rem]"),
};

const variantClasses: Record<ButtonVariant, ClassValue> = {
	[ButtonVariant.Dark]: tw("bg-fcrdarkgray [&:not(:disabled):hover]:bg-[#3C3C3C] text-white"),
	[ButtonVariant.White]: tw("bg-white [&:not(:disabled):hover]:bg-white/80 text-fcrdarkgray"),
	[ButtonVariant.Outlined]: tw(
		"text-fcrdarkgray border-fcrlightgray border [&:not(:disabled):hover]:border-fcrdarkgray",
	),
	[ButtonVariant.OutlinedWhite]: tw(
		"text-white border-fcrlightgray border border-white/16 [&:not(:disabled):hover]:bg-white/10 [&:not(:disabled):hover]:border-white/20 [&:not(:disabled):hover]:backdrop-blur-sm",
	),
};

export function getButtonClass(variant: ButtonVariant, size: ButtonSize): ClassValue {
	return tw(commonClass, sizeClasses[size], variantClasses[variant]);
}

const loaderVariantClasses: Record<ButtonVariant, ClassValue> = {
	[ButtonVariant.Dark]: tw("text-white"),
	[ButtonVariant.White]: tw("text-fcrdarkgray"),
	[ButtonVariant.Outlined]: tw("text-fcrdarkgray"),
	[ButtonVariant.OutlinedWhite]: tw("text-white"),
};

export function getButtonLoaderClass(variant: ButtonVariant): ClassValue {
	return loaderVariantClasses[variant];
}
